/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

module.exports = require('./lib/ReactDOM');




//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 505
// module chunks = 60